import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

/**
 * Pill-shaped two-position toggle that switches between dark and light themes.
 * Variant 'sidebar' is compact and fits the bottom of the side nav.
 */
export function ThemeToggle({ variant = 'sidebar' }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === 'light';

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={toggle}
        aria-label={isLight ? 'Mudar para tema escuro' : 'Mudar para tema claro'}
        title={isLight ? 'Tema escuro' : 'Tema claro'}
        data-testid="theme-toggle-icon"
        className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[#27272A] text-[#A1A1AA] hover:text-white hover:border-[#D4AF37] transition-colors"
      >
        {isLight ? <Moon size={16} /> : <Sun size={16} />}
      </button>
    );
  }

  return (
    <div
      role="group"
      aria-label="Alternar tema"
      data-testid="theme-toggle"
      className="relative flex items-center w-full rounded-full p-1 border border-[#27272A] bg-[#141414] overflow-hidden"
    >
      {/* Sliding knob */}
      <div
        aria-hidden="true"
        className="absolute top-1 bottom-1 left-1 rounded-full bg-[#D4AF37] transition-transform duration-300 ease-out"
        style={{
          width: 'calc(50% - 4px)',
          transform: isLight ? 'translateX(100%)' : 'translateX(0)',
        }}
      />
      <button
        type="button"
        onClick={() => !isLight ? null : toggle()}
        aria-pressed={!isLight}
        data-testid="theme-toggle-dark"
        className={`relative z-10 flex-1 flex items-center justify-center gap-1.5 py-1.5 text-xs font-medium rounded-full transition-colors ${
          !isLight ? 'text-black' : 'text-[#A1A1AA] hover:text-white'
        }`}
      >
        <Moon size={12} /> Escuro
      </button>
      <button
        type="button"
        onClick={() => isLight ? null : toggle()}
        aria-pressed={isLight}
        data-testid="theme-toggle-light"
        className={`relative z-10 flex-1 flex items-center justify-center gap-1.5 py-1.5 text-xs font-medium rounded-full transition-colors ${
          isLight ? 'text-black' : 'text-[#A1A1AA] hover:text-white'
        }`}
      >
        <Sun size={12} /> Claro
      </button>
    </div>
  );
}

export default ThemeToggle;
